import React from 'react';

const brands = [
  { name: 'Daikin', tagline: 'Global Leader' },
  { name: 'LG', tagline: 'Innovation for a Better Life' },
  { name: 'Samsung', tagline: 'Inspire the World' },
  { name: 'Carrier', tagline: 'Turn to the Experts' },
  { name: 'TCL', tagline: 'The Creative Life' },
  { name: 'Midea', tagline: 'Make Yourself at Home' },
  { name: 'Mitsubishi', tagline: 'Changes for the Better' },
  { name: 'Hisense', tagline: 'Laser TV Pioneer' },
];

export const BrandsGrid = () => {
  return (
    <section data-testid="brands-section" className="py-16 bg-[#0D1233] border-y border-white/5">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <p className="text-sm uppercase tracking-[0.2em] text-[#00D9FF] font-bold mb-3">Trusted Brands</p>
          <h2 className="text-2xl md:text-3xl font-bold text-white">
            We Service All Major Brands
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 max-w-6xl mx-auto">
          {brands.map((brand, i) => (
            <div
              key={i}
              className="group bg-white/[0.03] hover:bg-white/[0.08] border border-white/[0.06] hover:border-[#00D9FF]/30 rounded-xl p-4 flex flex-col items-center justify-center text-center transition-all duration-300 hover:-translate-y-1"
              data-testid={`brand-${brand.name.toLowerCase()}`}
            >
              <span className="text-xl font-black text-white group-hover:text-[#00D9FF] transition-colors tracking-tight leading-tight">
                {brand.name}
              </span>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          Plus many more. Not sure if we service your brand? Just ask.
        </p>
      </div>
    </section>
  );
};
